<mat-form-field appearance="outline">
  <mat-label>Partner filter</mat-label>
  <mat-chip-grid #partnerChipList aria-label="Partnere">
    <input
      placeholder="Vælg partner..."
      #partnerInput
      [formControl]="partnerCtrl"
      [matAutocomplete]="partnerAuto"
      [matChipInputFor]="partnerChipList"
      />
      @for (partner of selectedPartners; track partner) {
        <mat-chip-row removable (removed)="removePartner(partner)">
          <span class="ellipsis" [matTooltip]="partner.name">{{ partner.name }}</span>
          <mat-icon matChipRemove matTooltip="Fjern partner fra filter">cancel</mat-icon>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <mat-autocomplete #partnerAuto="matAutocomplete" (optionSelected)="partnerSelected($event)">
      @for (partner of filteredPartners | async; track partner) {
        <mat-option [value]="partner">
          {{ partner.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
